import React from 'react';

const Image = ({ src, alt }) => (
  <div className="container-fluid p-3">
    <img src={src} alt={alt} className="img-fluid rounded-4" />
  </div>
);

export default Image;